/* eslint-disable */
(function () {
  let myScript = document.querySelector('#instamed-sdk');

  let vals = {};

  if (myScript && myScript.attributes) {
    for (let i = 0; i < myScript.attributes.length; i++) {
      vals[myScript.attributes[i].name] = myScript.attributes[i].value;
    }
  }
  let initialized = false,
    start = new Date(),
    failedPollingRequests = 0,
    maxFailedPollingRequests = 1,
    failedRetrieveTokenRequests = 0,
    maxFailedRetrieveTokenRequests = 1,
    retryWaitTime = 10000,
    errorMessage =
      'An error occurred. Please try again or contact customer service.',
    cookieScripts = {};
  /*
  name - name of the cookie
  value - value of the cookie
  [expires] - expiration date of the cookie
  (defaults to end of current session)
  [path] - path for which the cookie is valid
  (defaults to path of calling document)
  [domain] - domain for which the cookie is valid
  (defaults to domain of calling document)
  [secure] - Boolean value indicating if the cookie transmission requires
  a secure transmission
  * an argument defaults when it is assigned null as a placeholder
  * a null placeholder is not required for trailing omitted arguments
  */
  cookieScripts.isSecure = function () {
    return true;
  };
  cookieScripts.setCookie = function (name, value, expires, path, domain) {
    document.cookie =
      name +
      '=' +
      escape(value) +
      (expires ? '; expires=' + expires.toGMTString() : '') +
      (path ? '; path=' + path : '') +
      (domain ? '; domain=' + domain : '') +
      (cookieScripts.isSecure() ? '; secure' : '');
  };

  /*
  name - name of the desired cookie
  return string containing value of specified cookie or null
  if cookie does not exist
  */

  cookieScripts.getCookie = function (name) {
    let dc = document.cookie;
    let prefix = name + '=';
    let begin = dc.indexOf('; ' + prefix);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else begin += 2;
    let end = document.cookie.indexOf(';', begin);
    if (end == -1) end = dc.length;
    return unescape(dc.substring(begin + prefix.length, end));
  };

  /*
  name - name of the cookie
  [path] - path of the cookie (must be same as path used to create cookie)
  [domain] - domain of the cookie (must be same as domain used to
  create cookie)
  path and domain default if assigned null or omitted if no explicit
  argument proceeds
  */

  cookieScripts.deleteCookie = function (name, path, domain) {
    if (cookieScripts.getCookie(name)) {
      document.cookie =
        name +
        '=' +
        (path ? '; path=' + path : '') +
        (domain ? '; domain=' + domain : '') +
        '; expires=Thu, 01-Jan-70 00:00:01 GMT';
    }
  };

  let InstaMed2 = {
    addJsonP: function () {
      /*
       * jQuery JSONP Core Plugin 2.4.0 (2012-08-21)
       *
       * https://github.com/jaubourg/jquery-jsonp
       *
       * Copyright (c) 2012 Julian Aubourg
       *
       * This document is licensed as free software under the terms of the
       * MIT License: http://www.opensource.org/licenses/mit-license.php
       */
      (function () {
        // ###################### UTILITIES ##

        // Noop
        function noop() {}
        // Generic callback
        function genericCallback(data) {
          lastValue = [data];
        }

        // Call if defined
        function callIfDefined(method, object, parameters) {
          return (
            method &&
            method.apply &&
            method.apply(object.context || object, parameters)
          );
        }

        // Give joining character given url
        function qMarkOrAmp(url) {
          return /\?/.test(url) ? '&' : '?';
        }

        let // String constants (for better minification)
          STR_ASYNC = 'async',
          STR_CHARSET = 'charset',
          STR_EMPTY = '',
          STR_ERROR = 'error',
          STR_INSERT_BEFORE = 'insertBefore',
          STR_JQUERY_JSONP = '_jqjsp',
          STR_ON = 'on',
          STR_ON_CLICK = STR_ON + 'click',
          STR_ON_ERROR = STR_ON + STR_ERROR,
          STR_ON_LOAD = STR_ON + 'load',
          STR_ON_READY_STATE_CHANGE = STR_ON + 'readystatechange',
          STR_READY_STATE = 'readyState',
          STR_REMOVE_CHILD = 'removeChild',
          STR_SCRIPT_TAG = '<script>',
          STR_SUCCESS = 'success',
          STR_TIMEOUT = 'timeout',
          // Window
          win = window,
          // Deferred
          Deferred = $.Deferred,
          // Head element
          head = $('head')[0] || document.documentElement,
          // Page cache
          pageCache = {},
          // Counter
          count = 0,
          // Last returned value
          lastValue,
          // ###################### DEFAULT OPTIONS ##
          xOptionsDefaults = {
            // beforeSend: undefined,
            // cache: false,
            callback: STR_JQUERY_JSONP,
            // callbackParameter: undefined,
            // charset: undefined,
            // complete: undefined,
            // context: undefined,
            // data: "",
            // dataFilter: undefined,
            // error: undefined,
            // pageCache: false,
            // success: undefined,
            // timeout: 0,
            // traditional: false,
            url: location.href
          },
          // opera demands sniffing :/
          opera = win.opera,
          // IE < 10
          oldIE = !!$('<div>').html('<!--[if IE]><i><![endif]-->').find('i')
            .length;

        // ###################### MAIN FUNCTION ##
        function jsonp(xOptions) {
          // Build data with default
          xOptions = $.extend({}, xOptionsDefaults, xOptions);

          // References to xOptions members (for better minification)
          let successCallback = xOptions.success,
            errorCallback = xOptions.error,
            completeCallback = xOptions.complete,
            dataFilter = xOptions.dataFilter,
            callbackParameter = xOptions.callbackParameter,
            successCallbackName = xOptions.callback,
            cacheFlag = xOptions.cache,
            pageCacheFlag = xOptions.pageCache,
            charset = xOptions.charset,
            url = xOptions.url,
            data = xOptions.data,
            timeout = xOptions.timeout,
            pageCached,
            // Abort/done flag
            done = 0,
            // Life-cycle functions
            cleanUp = noop,
            // Support lets
            supportOnload,
            supportOnreadystatechange,
            // Request execution lets
            firstChild,
            script,
            scriptAfter,
            timeoutTimer;

          // If we have Deferreds:
          // - substitute callbacks
          // - promote xOptions to a promise
          Deferred &&
            Deferred(function (defer) {
              defer.done(successCallback).fail(errorCallback);
              successCallback = defer.resolve;
              errorCallback = defer.reject;
            }).promise(xOptions);

          // Create the abort method
          xOptions.abort = function () {
            !done++ && cleanUp();
          };

          // Call beforeSend if provided (early abort if false returned)
          if (
            callIfDefined(xOptions.beforeSend, xOptions, [xOptions]) === !1 ||
            done
          ) {
            return xOptions;
          }

          // Control entries
          url = url || STR_EMPTY;
          data = data
            ? typeof data == 'string'
              ? data
              : $.param(data, xOptions.traditional)
            : STR_EMPTY;

          // Build final url
          url += data ? qMarkOrAmp(url) + data : STR_EMPTY;

          // Add callback parameter if provided as option
          callbackParameter &&
            (url +=
              qMarkOrAmp(url) + encodeURIComponent(callbackParameter) + '=?');

          // Add anticache parameter if needed
          !cacheFlag &&
            !pageCacheFlag &&
            (url += qMarkOrAmp(url) + '_' + new Date().getTime() + '=');

          // Replace last ? by callback parameter
          url = url.replace(/=\?(&|$)/, '=' + successCallbackName + '$1');

          // Success notifier
          function notifySuccess(json) {
            if (!done++) {
              cleanUp();
              // Pagecache if needed
              pageCacheFlag && (pageCache[url] = {s: [json]});
              // Apply the data filter if provided
              dataFilter && (json = dataFilter.apply(xOptions, [json]));
              // Call success then complete
              callIfDefined(successCallback, xOptions, [
                json,
                STR_SUCCESS,
                xOptions
              ]);
              callIfDefined(completeCallback, xOptions, [
                xOptions,
                STR_SUCCESS
              ]);
            }
          }

          // Error notifier
          function notifyError(type) {
            if (!done++) {
              // Clean up
              cleanUp();
              // If pure error (not timeout), cache if needed
              pageCacheFlag && type != STR_TIMEOUT && (pageCache[url] = type);
              // Call error then complete
              callIfDefined(errorCallback, xOptions, [xOptions, type]);
              callIfDefined(completeCallback, xOptions, [xOptions, type]);
            }
          }

          // Check page cache
          if (pageCacheFlag && (pageCached = pageCache[url])) {
            pageCached.s
              ? notifySuccess(pageCached.s[0])
              : notifyError(pageCached);
          } else {
            // Install the generic callback
            // (BEWARE: global namespace pollution ahoy)
            win[successCallbackName] = genericCallback;

            // Create the script tag
            script = $(STR_SCRIPT_TAG)[0];
            script.id = STR_JQUERY_JSONP + count++;

            // Set charset if provided
            if (charset) {
              script[STR_CHARSET] = charset;
            }

            opera && opera.version() < 11.6
              ? // onerror is not supported: do not set as async and assume in-order execution.
                // Add a trailing script to emulate the event
                ((scriptAfter = $(STR_SCRIPT_TAG)[0]).text =
                  "document.getElementById('" +
                  script.id +
                  "')." +
                  STR_ON_ERROR +
                  '()')
              : // onerror is supported: set the script as async to avoid requests blocking each others
                (script[STR_ASYNC] = STR_ASYNC);

            // Internet Explorer: event/htmlFor trick
            if (oldIE) {
              script.htmlFor = script.id;
              script.event = STR_ON_CLICK;
            }

            // Attached event handlers
            script[STR_ON_LOAD] = script[STR_ON_ERROR] = script[
              STR_ON_READY_STATE_CHANGE
            ] = function (result) {
              // Test readyState if it exists
              if (
                !script[STR_READY_STATE] ||
                !/i/.test(script[STR_READY_STATE])
              ) {
                try {
                  script[STR_ON_CLICK] && script[STR_ON_CLICK]();
                } catch (_) {}

                result = lastValue;
                lastValue = 0;
                result ? notifySuccess(result[0]) : notifyError(STR_ERROR);
              }
            };

            // Set source
            script.src = url;

            // Re-declare cleanUp function
            cleanUp = function (i) {
              timeoutTimer && clearTimeout(timeoutTimer);
              script[STR_ON_READY_STATE_CHANGE] = script[STR_ON_LOAD] = script[
                STR_ON_ERROR
              ] = null;
              head[STR_REMOVE_CHILD](script);
              scriptAfter && head[STR_REMOVE_CHILD](scriptAfter);
            };

            // Append main script
            head[STR_INSERT_BEFORE](script, (firstChild = head.firstChild));

            // Append trailing script if needed
            scriptAfter && head[STR_INSERT_BEFORE](scriptAfter, firstChild);

            // If a timeout is needed, install it
            timeoutTimer =
              timeout > 0 &&
              setTimeout(function () {
                notifyError(STR_TIMEOUT);
              }, timeout);
          }

          return xOptions;
        }

        // ###################### SETUP FUNCTION ##
        jsonp.setup = function (xOptions) {
          $.extend(xOptionsDefaults, xOptions);
        };

        // ###################### INSTALL in jQuery ##
        $.jsonp = jsonp;
      })(jQuery);
    },
    onReady: function () {
      InstaMed2.addJsonP();

      if (InstaMed2.isInContext() || InstaMed2.isForceEmbedded()) {
        InstaMed2.init();
      }
      InstaMed2.enhanced = false;
      let id = 'cardnum';
      let cmp = $('#' + id);
      if (
        cmp != undefined &&
        cmp != null &&
        cmp.length > 0 &&
        cmp[0].id == id
      ) {
        InstaMed2.enhanced = true;
      }
      InstaMed2.enhancedAutoPay = false;
      id = 'CardEntry-CardNumber';
      cmp = $('#' + id);
      if (
        cmp != undefined &&
        cmp != null &&
        cmp.length > 0 &&
        cmp[0].id == id
      ) {
        InstaMed2.enhancedAutoPay = true;
      }

      InstaMed2.enhancedAutoPay2 = false;
      id = 'CardEntry';
      cmp = $('#' + id);
      if (
        cmp != undefined &&
        cmp != null &&
        cmp.length > 0 &&
        cmp[0].id == id
      ) {
        InstaMed2.enhancedAutoPay = false;
        InstaMed2.enhancedAutoPay2 = true;
      }

      let cardHtml =
        '<p style="display:none" id="instamedcardinfo"><span id="instamedcardinfocontent">Card :</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="#" style="padding-left:10px" onclick="javascript: InstaMed2.removeCard(); return false;" >Remove</a></p>';
      let forceEmbeddedHtml = InstaMed2.isForceEmbedded()
        ? '<iframe name="instamed" style="height: 360px; width:100%; display:none; " id="instamed" src="about:blank"></iframe>'
        : '';
      let buttonHtml =
        '<div class="formbuttons"><input class="button nextstep" id="addCard" onclick="javascript: InstaMed2.addCard(); return false;" type="submit" value="Add Card"><br>' +
        forceEmbeddedHtml +
        '</div>';

      // let buttonHtml = '<p><form action="' + InstaMed2.addCard(null,null,null,true) + '" method="POST" target="instamed"> <input class="button nextstep" type="submit" value="Add Card"></form></p>';

      if (InstaMed2.enhanced) {
        $('#cardnum').hide();
        $('#expmonth').hide();
        $('#expyear').hide();
        $('#vernum').hide();
        $('#popupparentdiv_vernumicon').hide();
        $('label[for="cardnum"]').hide();
        $('label[for="vernum"]').hide();
        $('#expdate').hide();
        $('label[for="cardtype"]').html('Type');
        $('#cardnum')
          .parent()
          .find('.helptext')
          .each(function () {
            this.style.display = 'none';
          });
        // $('#cardtype').after('<p class="helptext">&nbsp;</p><p class="helptext">This field is required</p>');
        $('#cardtype').after(cardHtml);
        $('#cardtype').after(buttonHtml);
        // $('#cardType').after('<input class="button nextstep" type="submit" name="ccaddcard" id="ccaddcard" value="Add Card" title="Add Card" autocomplete="off">');
        $('#savecard').parent().before('<p></p>');
        $('#popupvernum').hide();
        $('#cardtype').hide();
        $('label[for="cardtype"]').hide();
        $('#ccaddcard').click(function () {
          let cardType = $('#cardtype').val();
          if (cardType != '') {
            InstaMed2.addCard();
          } else {
            InstaMed2.onDataReceived({
              ExpDate: '  /  ',
              Token: '',
              CVN: ''
            });
          }
        });
      }

      if (InstaMed2.enhancedAutoPay) {
        $('div.CardEntryCardGroup > div.CardEntry-Field').hide();
        let cmpCardHolderName = $('#CardEntry-CardholderName')
          .parent()
          .parent();
        cmpCardHolderName.show();
        cmpCardHolderName.after(cardHtml);
        cmpCardHolderName.after(buttonHtml);
      }

      if (InstaMed2.enhancedAutoPay2) {
        $('div#CardEntry div.CardEntry-Field').hide();
        let cmpCardHolderName = $('#CardEntry-CardholderName').parent();
        cmpCardHolderName.show();
        cmpCardHolderName.after(cardHtml);
        cmpCardHolderName.after(buttonHtml);
        $('div#CardEntry-BillingInfoDiv > div.CardEntry-Field').show();
        $('div#AddressEntryFields > div.CardEntry-Field').show();
      }

      InstaMed2.handleSafari(InstaMed2.getHostname());
    },
    isForceEmbedded: function () {
      if (InstaMed2.isMobile()) {
        return vals['data-mobiledisplaymode'] == 'forceEmbedded';
      }
      return vals['data-displaymode'] == 'forceEmbedded';
    },
    handleSafari: function (url) {
      return false;
      if (
        InstaMed2.isSafari() &&
        (InstaMed2.isEmbedded() || InstaMed2.isInContext())
      ) {
        let cookie_name = 'safari_cookie_fix-' + url;
        let val = cookieScripts.getCookie(cookie_name);
        if (val == undefined || val == null || val == '') {
          let vr = new Date();
          vr.setDate(vr.getDate() + 1);
          cookieScripts.setCookie(cookie_name, 'fixed', vr, '/', null);
          window.location.href = url + 'Form/Payments/Init?lightWeight=true';
          return true;
        }
      }
      return false;
    },
    addCard: function (callback, corporateId, hostname, manual, accountID) {
      failedPollingRequests = 0;
      failedRetrieveTokenRequests = 0;

      /*
       *  0. Generate a unique ID - client side or server side
       *  1. Create an iframe that uses postMessage to transmit information from/to the main page
       *  2. iframe should launch a payment page w/ a token and then poll for a result
       *  3. once the iframe gets the result, it should send it via postMessage to the parent page
       */

      InstaMed2.init();

      InstaMed2.callback = callback;
      guid = InstaMed2.generateUUID();
      let cid = InstaMed2.getCorporateID();
      if (
        corporateId != undefined &&
        corporateId != null &&
        corporateId != ''
      ) {
        cid = corporateId;
      }
      InstaMed2.hostnameUrl = '';
      if (hostname == undefined || hostname == null || hostname == '') {
        InstaMed2.hostnameUrl = InstaMed2.getHostname();
      } else {
        InstaMed2.hostnameUrl = hostname;
      }

      if (InstaMed2.handleSafari(InstaMed2.hostnameUrl)) {
        return;
      }

      let aid = '';
      if (accountID != undefined && accountID != null && accountID != '') {
        aid = accountID;
        cid = '';
      }

      let launchUrl =
        InstaMed2.hostnameUrl +
        'Form/Payments/NewCard?&tokenID=' +
        guid +
        (aid != '' ? '&aid=' + aid : '') +
        (cid != '' ? '&cid=' + cid : '') +
        (InstaMed2.isInContext() && !InstaMed2.isForceEmbedded()
          ? '&incontext=true'
          : '') +
        (InstaMed2.isEmbedded() ||
        InstaMed2.isMobile() ||
        InstaMed2.isForceEmbedded()
          ? '&lightweight=true'
          : '');
      if (!manual) {
        InstaMed2.launch(launchUrl);
      }
      start = new Date();
      InstaMed2.pollEvent = setTimeout('InstaMed2.poll();', 5000);
      return launchUrl;
    },
    isInContext: function () {
      if (InstaMed2.isMobile()) {
        return vals['data-patientportaldisplaymode'] == 'incontext';
      }
      return vals['data-displaymode'] == 'incontext';
    },
    isEmbedded: function () {
      if (InstaMed2.isMobile()) {
        return vals['data-mobiledisplaymode'] == 'embedded';
      }
      return vals['data-displaymode'] == 'embedded';
    },
    getHostname: function () {
      let env = vals['data-environment'];
      if (env == 'DEV') {
        return 'https://dev5.instamedtest.com/pay/';
      } else if (env == 'QA') {
        return 'https://pay-qa.instamedtest.com/';
      } else if (env == 'UAT') {
        return 'https://pay-uat.instamedtest.com/';
      } else if (env == 'STG') {
        return 'https://pay-staging.instamed.com/';
      }

      return 'https://pay.instamed.com/';
      // return "https://dev5.instamedtest.com/InstaMed.Web.PaymentHPM/";
      //	return "https://pay-qa.instamedtest.com/";
    },
    getCorporateID: function () {
      return InstaMed2.corporateID; // b
    },
    getMode: function () {
      return InstaMed2.mode;
    },
    generateUUID: function () {
      let d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); // use high-precision timer if available
      }
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          let r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    poll: function () {
      if (typeof $.jsonp !== 'function') {
        InstaMed2.addJsonP();
      }
      $.jsonp({
        crossDomain: true,
        contentType: 'application/json; charset=utf-8',
        url:
          InstaMed2.hostnameUrl +
          'Forms/WebServices/TokenService.asmx/GetStatus?tokenID=' +
          guid +
          '&callback=?',
        // data: { tokenID: guid, callback: 'InstaMed2.onStatusReceived'},
        callback: 'callback',
        dataType: 'jsonp',
        success: InstaMed2.onStatusReceived,
        error: InstaMed2.onErrorReceived
      });
    },
    onErrorReceived: function (data) {
      failedPollingRequests += 1;
      if (failedPollingRequests < maxFailedPollingRequests) {
        InstaMed2.pollEvent = setTimeout('InstaMed2.poll();', retryWaitTime);
      } else {
        InstaMed2.onDataReceived({
          ExpDate: '  /  ',
          Token: '',
          CVN: '',
          IsError: true,
          Error: errorMessage
        });
      }
    },
    onStatusReceived: function (data) {
      if (data.Status == 'New' && InstaMed2.inContextClosed) {
        InstaMed2.closeIframe({
          ExpDate: '  /  ',
          Token: '',
          CVN: '',
          Status: 'Cancelled',
          TokenID: guid
        });
      } else if (data.Status == 'New') {
        let t2 = new Date().getTime();
        let t1 = start.getTime();
        if (t2 - t1 < 1000 * 60 * 5) {
          InstaMed2.pollEvent = setTimeout('InstaMed2.poll();', 2000);
        }
      } else if (data.Status == 'Cancelled') {
        InstaMed2.closeIframe(data);
      } else if (data.Status == 'Complete') {
        InstaMed2.retrieveToken();
      }
      return true;
    },
    retrieveToken: function () {
      $.jsonp({
        crossDomain: true,
        contentType: 'application/json; charset=utf-8',
        url:
          InstaMed2.hostnameUrl +
          'Forms/WebServices/TokenService.asmx/GetTokenData?tokenID=' +
          guid +
          '&callback=?',
        // data: { tokenID: guid },
        callback: 'callback',
        dataType: 'jsonp',
        success: InstaMed2.onDataReceived,
        error: InstaMed2.onDataErrorReceived
      });
    },
    onDataReceived: function (data) {
      let errorHtml = '';
      if (data && data.IsError) {
        errorHtml = errorMessage;
      }
      let parts = data.ExpDate.split('/');
      let month = parts[0];
      let year = '20' + parts[1];
      if (InstaMed2.isEnhanced()) {
        document.getElementById('cardnum').value = data.Token;
        document.getElementById('expmonth').value = month;
        document.getElementById('expyear').value = year;
        if (document.getElementById('vernum')) {
          document.getElementById('vernum').value = data.CVN;
        }
        document.getElementById('cardtype').value = InstaMed2.getCardType(
          data.Token
        );
        $('#instamedcardinfocontent').html(
          'Card: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
            InstaMed2.maskCardNumber(data.Token) +
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
            month +
            '/' +
            year
        );
        if (errorHtml != '') {
          $('#instamedcardinfocontent').html(errorHtml);
        }
        $('#instamedcardinfo').show();
      } else if (
        InstaMed2.isEnhancedAutoPay() ||
        InstaMed2.isEnhancedAutoPay2()
      ) {
        document.getElementById('CardEntry-CardNumber').value = data.Token;
        document.getElementById('CardEntry-ExpMM').value = month;
        document.getElementById('CardEntry-ExpYYYY').value = year;
        if (document.getElementById('CardEntry-SecurityCode')) {
          document.getElementById('CardEntry-SecurityCode').value = data.CVN;
        }

        if (InstaMed2.isEnhancedAutoPay2()) {
          document.getElementById('CardEntry-SecurityCode').value = data.CVN;
          $afe.select('#CardEntry-CardNumber').trigger('blur');
          $afe.select('#CardEntry-ExpMM').trigger('blur');
          $afe.select('#CardEntry-ExpYYYY').trigger('blur');
          $afe.select('#CardEntry-SecurityCode').trigger('blur');
        }
        $('#instamedcardinfocontent').html(
          'Card: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
            InstaMed2.maskCardNumber(data.Token) +
            '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
            month +
            '/' +
            year
        );
        if (errorHtml != '') {
          $('#instamedcardinfocontent').html(errorHtml);
        }
        $('#instamedcardinfo').show();
      }

      InstaMed2.closeIframe(data);
      return true;
    },
    onDataErrorReceived: function (data) {
      failedRetrieveTokenRequests += 1;
      if (failedRetrieveTokenRequests < maxFailedRetrieveTokenRequests) {
        setTimeout('InstaMed2.retrieveToken();', retryWaitTime);
      } else {
        InstaMed2.onDataReceived({
          ExpDate: '  /  ',
          Token: '',
          CVN: '',
          IsError: true,
          ErrorMessage: errorMessage
        });
      }
    },
    isEnhanced: function () {
      return InstaMed2.enhanced;
    },
    isEnhancedAutoPay: function () {
      return InstaMed2.enhancedAutoPay;
    },
    isEnhancedAutoPay2: function () {
      return InstaMed2.enhancedAutoPay2;
    },
    getCardType: function (cardNumber) {
      let cardType = '';
      if (cardNumber) {
        cardNumber = cardNumber.replace(/\D/g, '');

        let first = cardNumber.substr(0, 1);
        let firstTwo = cardNumber.substr(0, 2);
        let firstThree = cardNumber.substr(0, 3);
        let firstFour = cardNumber.substr(0, 4);
        let lastFour = cardNumber.substring(
          Math.max(cardNumber.length - 4, 0),
          cardNumber.length
        );

        let cardType;

        if (first == '4') {
          cardType = '1';
        } else if (first == '5') {
          cardType = '2';
        } else if (firstTwo == '34' || firstTwo == '37') {
          cardType = '3';
        } else if (firstFour == '6011' || firstTwo == '65') {
          cardType = '4';
        } else if (
          firstThree == '300' ||
          firstThree == '305' ||
          firstTwo == '36' ||
          firstTwo == '38'
        ) {
          cardType = '5';
        } else if (first == '2') {
          let bin =
            cardNumber.length >= 6 ? parseInt(cardNumber.substr(0, 6)) : null;
          if (bin >= 222100 && bin <= 272099) {
            cardType = '2';
          } else {
          }
        }
      }
      return cardType;
    },
    sendMessageToNativeApp: function (messageType, content) {
      if (!content) {
        content = '';
      }

      if (InstaMed2.isAndroid()) {
        if (window.HTML && window.HTML.handleInstaMedMessage) {
          window.HTML.handleInstaMedMessage(messageType, content);
        } else if (window.Android && window.Android.handleInstaMedMessage) {
          window.Android.handleInstaMedMessage(messageType, content);
        }
      } else {
        let iframe = document.createElement('IFRAME');
        iframe.setAttribute('src', messageType + ':' + content);
        document.documentElement.appendChild(iframe);
        iframe.parentNode.removeChild(iframe);
        iframe = null;
      }
    },
    isNative: function () {
      return false; // TODO: detect native
    },
    closeIframe: function (data) {
      if (InstaMed2.callback != undefined) {
        InstaMed2.callback(data);
      }
      let iframe = document.getElementById('instamed');
      if (iframe && iframe.getAttribute('data-incontext') == 'true') {
        iframe.style.visibility = 'hidden';
        iframe.style.opacity = 0;
        document.body.style.overflow = 'visible';
      }
      if (InstaMed2.doPopup() && !InstaMed2.isForceEmbedded()) {
        if (InstaMed2.childWindow) {
          InstaMed2.childWindow.close();
        }
        if (InstaMed2.isNative()) {
          InstaMed2.sendMessage('js-frame', 'do-close');
        }
      }
      if (InstaMed2.isForceEmbedded()) {
        iframe.style.display = 'none';
      }
    },
    removeCard: function () {
      if (InstaMed2.isEnhanced()) {
        document.getElementById('cardnum').value = '';
        document.getElementById('expmonth').value = '';
        document.getElementById('expyear').value = '';
        if (document.getElementById('vernum')) {
          document.getElementById('vernum').value = '';
        }
        document.getElementById('cardtype').value = '';
      } else if (
        InstaMed2.isEnhancedAutoPay() ||
        InstaMed2.isEnhancedAutoPay2()
      ) {
        document.getElementById('CardEntry-CardNumber').value = '';
        document.getElementById('CardEntry-ExpMM').value = '';
        document.getElementById('CardEntry-ExpYYYY').value = '';
        if (document.getElementById('CardEntry-SecurityCode'))
          document.getElementById('CardEntry-SecurityCode').value = '';
        if (InstaMed2.isEnhancedAutoPay2()) {
          $afe.select('#CardEntry-CardNumber').trigger('blur');
          $afe.select('#CardEntry-ExpMM').trigger('blur');
          $afe.select('#CardEntry-ExpYYYY').trigger('blur');
          $afe.select('#CardEntry-SecurityCode').trigger('blur');
        }
      }
      $('#instamedcardinfocontent').html('Card: ');
      $('#instamedcardinfo').hide();
    },
    maskCardNumber: function (cardNumber) {
      if (!cardNumber || cardNumber.length < 4) {
        return '';
      }
      if (cardNumber.indexOf('XXXX') != -1) {
        return cardNumber;
      }
      let len = cardNumber.length;
      let num = cardNumber.substring(len - 4);
      if (len == 16) {
        return 'XXXXXXXXXXXX' + num;
      } else {
        return 'XXXXXXXXXXX' + num;
      }
    },
    isIE: function () {
      return (
        !InstaMed2.isOpera() &&
        (InstaMed2.check(/msie/) || InstaMed2.check(/trident/))
      );
    },
    isIE7: function () {
      return false; // InstaMed.isIE() && ((InstaMed.check(/msie 7/) && InstaMed.docMode() != 8 && InstaMed.docMode() != 9 && InstaMed.docMode() != 10) || InstaMed.docMode() == 7);
    },
    isSafari: function () {
      let userAgentString =
        navigator.userAgent || navigator.vendor || window.opera;
      return (
        userAgentString &&
        userAgentString.indexOf('Safari') != -1 &&
        userAgentString.indexOf('Chrome') == -1
      );

      return isSafari;
    },
    doPopup: function () {
      return (
        /* InstaMed2.isSafari() ||*/ InstaMed2.isMobile() &&
        !InstaMed2.isEmbedded() &&
        !InstaMed2.isInContext()
      );
    },
    isMobile: function () {
      let userAgentString =
        navigator.userAgent || navigator.vendor || window.opera;
      if (
        userAgentString != null &&
        (userAgentString.indexOf('iPhone') != -1 ||
          userAgentString.indexOf('iPad') != -1 ||
          // (context.Request.Browser.MobileDeviceModel == "iPhone" && context.Request.Browser.MobileDeviceModel == "Apple")) ||
          userAgentString.indexOf('Android') !=
            -1 /* && userAgentString.Contains("Mobile")*/ ||
          userAgentString.indexOf('Windows Phone OS') != -1 ||
          userAgentString.indexOf('BB10') != -1 ||
          userAgentString.indexOf('iPod') !=
            -1) /* || (context.Request.Browser.MobileDeviceModel == "iPod" && context.Request.Browser.MobileDeviceModel == "Apple")*/
      ) {
        return true;
      }
      return false;
    },
    launch: function (page) {
      if (InstaMed2.doPopup() && !InstaMed2.isForceEmbedded()) {
        InstaMed2.childWindow = window.open(page);
      } else {
        if (InstaMed2.isForceEmbedded()) {
          let iframe = document.getElementById('instamed');
          if (iframe) {
            iframe.style.display = 'block';
          }
        }
        if (document.getElementById('instamed')) {
          document.getElementById('instamed').setAttribute('src', page);
        }
      }
    },
    init: function () {
      if (!initialized) {
        initialized = true;
      }
      if (
        !InstaMed2.doPopup() &&
        InstaMed2.isInContext() &&
        !InstaMed2.isForceEmbedded()
      ) {
        // AddIFrame();
      }
    },
    check: function (regex) {
      return regex.test(navigator.userAgent.toLowerCase());
    },
    isOpera: function () {
      return InstaMed2.check(/opera/);
    },
    docMode: function () {
      return document.documentMode;
    }
  };
  var guid = InstaMed2.generateUUID();

  /* !
   *
   * Portions derived from
   * jQuery postMessage - v0.5 - 9/11/2009
   * http://benalman.com/projects/jquery-postmessage-plugin/
   *
   * Copyright (c) 2009 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */

  // '$:nomunge'; // Used by YUI compressor.
  let PostMessageHelper = {
    // A few lets used in non-awesome browsers.
    interval_id: undefined,
    last_hash: undefined,
    cache_bust: 1,

    // A let used in awesome browsers.
    rm_callback: undefined,
    p_receiveMessage: undefined,
    // A few convenient shortcuts.
    window: this,
    FALSE: !1,

    // Reused internal strings.
    postMessage: 'postMessage',
    addEventListener: 'addEventListener',

    // I couldn't get window.postMessage to actually work in Opera 9.64!
    has_postMessage: function () {
      return (
        !InstaMed2.isIE7() &&
        (!InstaMed2.isIE() || vals['data-displaymode'] != 'window') &&
        PostMessageHelper.isFunction(window['postMessage'])
      );
    },
    isFunction: function (functionToCheck) {
      let getType = {};
      return (
        functionToCheck &&
        getType.toString.call(functionToCheck) === '[object Function]'
      );
    },
    // Method: jQuery.postMessage
    //
    // This method will call window.postMessage if available, setting the
    // targetOrigin parameter to the base of the target_url parameter for maximum
    // security in browsers that support it. If window.postMessage is not available,
    // the target window's location.hash will be used to pass the message. If an
    // object is passed as the message param, it will be serialized into a string
    // using the jQuery.param method.
    //
    // Usage:
    //
    // > jQuery.postMessage( message, target_url [, target ] );
    //
    // Arguments:
    //
    //  message - (String) A message to be passed to the other frame.
    //  message - (Object) An object to be serialized into a params string, using
    //    the jQuery.param method.
    //  target_url - (String) The URL of the other frame this window is
    //    attempting to communicate with. This must be the exact URL (including
    //    any query string) of the other window for this script to work in
    //    browsers that don't support window.postMessage.
    //  target - (Object) A reference to the other frame this window is
    //    attempting to communicate with. If omitted, defaults to `parent`.
    //
    // Returns:
    //
    //  Nothing.

    doPostMessage: function (message, target_url, target) {
      if (!target_url) {
        return;
      }

      // Serialize the message if not a string. Note that this is the only real
      // jQuery dependency for this script. If removed, this script could be
      // written as very basic JavaScript.
      message =
        typeof message === 'string' ? message : message /* $.param( message )*/;

      // Default to parent if unspecified.
      target = target || parent;

      if (PostMessageHelper.has_postMessage()) {
        // The browser supports window.postMessage, so call it with a targetOrigin
        // set appropriately, based on the target_url parameter.
        target['postMessage'](
          message,
          target_url.replace(/([^:]+:\/\/[^\/]+).*/, '$1')
        );
      } else if (target_url) {
        // The browser does not support window.postMessage, so set the location
        // of the target to target_url#message. A bit ugly, but it works! A cache
        // bust parameter is added to ensure that repeat messages trigger the
        // callback.
        target.location =
          target_url.replace(/#.*$/, '') +
          '#' +
          +new Date() +
          PostMessageHelper.cache_bust++ +
          '&' +
          message;
      }
    },

    // Method: jQuery.receiveMessage
    //
    // Register a single callback for either a window.postMessage call, if
    // supported, or if unsupported, for any change in the current window
    // location.hash. If window.postMessage is supported and source_origin is
    // specified, the source window will be checked against this for maximum
    // security. If window.postMessage is unsupported, a polling loop will be
    // started to watch for changes to the location.hash.
    //
    // Note that for simplicity's sake, only a single callback can be registered
    // at one time. Passing no params will unbind this event (or stop the polling
    // loop), and calling this method a second time with another callback will
    // unbind the event (or stop the polling loop) first, before binding the new
    // callback.
    //
    // Also note that if window.postMessage is available, the optional
    // source_origin param will be used to test the event.origin property. From
    // the MDC window.postMessage docs: This string is the concatenation of the
    // protocol and "://", the host name if one exists, and ":" followed by a port
    // number if a port is present and differs from the default port for the given
    // protocol. Examples of typical origins are https://example.org (implying
    // port 443), http://example.net (implying port 80), and http://example.com:8080.
    //
    // Usage:
    //
    // > jQuery.receiveMessage( callback [, source_origin ] [, delay ] );
    //
    // Arguments:
    //
    //  callback - (Function) This callback will execute whenever a <jQuery.postMessage>
    //    message is received, provided the source_origin matches. If callback is
    //    omitted, any existing receiveMessage event bind or polling loop will be
    //    canceled.
    //  source_origin - (String) If window.postMessage is available and this value
    //    is not equal to the event.origin property, the callback will not be
    //    called.
    //  source_origin - (Function) If window.postMessage is available and this
    //    function returns false when passed the event.origin property, the
    //    callback will not be called.
    //  delay - (Number) An optional zero-or-greater delay in milliseconds at
    //    which the polling loop will execute (for browser that don't support
    //    window.postMessage). If omitted, defaults to 100.
    //
    // Returns:
    //
    //  Nothing!

    receiveMessage: function (callback, source_origin, delay) {
      if (PostMessageHelper.has_postMessage()) {
        // Since the browser supports window.postMessage, the callback will be
        // bound to the actual event associated with window.postMessage.

        if (callback) {
          // Unbind an existing callback if it exists.
          PostMessageHelper.rm_callback && PostMessageHelper.p_receiveMessage();

          // Bind the callback. A reference to the callback is stored for ease of
          // unbinding.
          PostMessageHelper.rm_callback = function (e) {
            if (
              (typeof source_origin === 'string' &&
                e.origin !== source_origin) ||
              (PostMessageHelper.isFunction(source_origin) &&
                source_origin(e.origin) === FALSE)
            ) {
              return FALSE;
            }
            callback(e);
          };
        }

        if (window[PostMessageHelper.addEventListener]) {
          window[
            callback
              ? PostMessageHelper.addEventListener
              : 'removeEventListener'
          ]('message', PostMessageHelper.rm_callback, PostMessageHelper.FALSE);
        } else {
          window[callback ? 'attachEvent' : 'detachEvent'](
            'onmessage',
            PostMessageHelper.rm_callback
          );
        }
      } else {
        // Since the browser sucks, a polling loop will be started, and the
        // callback will be called whenever the location.hash changes.

        PostMessageHelper.interval_id &&
          clearInterval(PostMessageHelper.interval_id);
        PostMessageHelper.interval_id = null;

        if (callback) {
          delay =
            typeof source_origin === 'number'
              ? source_origin
              : typeof delay === 'number'
              ? delay
              : 100;

          PostMessageHelper.interval_id = setInterval(function () {
            let hash = document.location.hash,
              re = /^#?\d+&/;
            if (hash !== PostMessageHelper.last_hash && re.test(hash)) {
              PostMessageHelper.last_hash = hash;
              callback({data: hash.replace(re, '')});
            }
          }, delay);
        }
      }
    }
  };

  // PostMessageHelper.has_postMessage = false;
  // PostMessageHelper.p_receiveMessage = PostMessageHelper.receiveMessage;
  function doHandleMessage(message) {
    let obj = {};
    try {
      // Parse the message data only if it's a string
      if (typeof message.data === 'string' && message.data.trim() !== '') {
        obj = JSON.parse(message.data);
      }
    } catch (e) {
      return e.message; // Return the error message if JSON parsing fails
    }
    // if (typeof JSON == 'undefined') {
    //   eval('obj = ' + message.data + ';');
    // } else if (typeof message.data == 'string' && message.data !== '') {
    //   obj = JSON.parse(message.data);
    // }
    if (obj.closeInContext) {
      let iframe = document.getElementById('instamed');
      if (iframe && iframe.getAttribute('data-incontext') == 'true') {
        iframe.style.visibility = 'hidden';
        iframe.style.opacity = 0;
        document.body.style.overflow = 'visible';
      }
      InstaMed2.inContextClosed = true;
      obj.retrieveResponse = true;
    }
    if (obj.retrieveResponse) {
      if (InstaMed2.pollEvent) {
        clearTimeout(InstaMed2.pollEvent);
      }
      InstaMed2.pollEvent = setTimeout('InstaMed2.poll();', 100);
    }
    if (obj.returnURL) {
      window.location.href = obj.returnURL;
    }
    if (obj.redirectIframeUrl) {
      // InstaMed2.launch(message.source.location.href);
      InstaMed2.launch(obj.redirectIframeUrl);
    }
    if (obj.launchInContext) {
      InstaMed2.inContextClosed = false;
      document.body.style.overflow = 'hidden';
      let iframe = document.getElementById('instamed');
      iframe.style.visibility = 'visible';
      iframe.style.opacity = 1;
    }
    if (
      window.location.hash != undefined &&
      window.location.hash != null &&
      window.location.hash != '' &&
      !PostMessageHelper.has_postMessage()
    ) {
      window.location.hash = '';
    }
  }
  try {
    PostMessageHelper.receiveMessage(doHandleMessage);
  } catch (error) {
    throw error; // Throw the error without any additional message or handling
  }
  // PostMessageHelper.receiveMessage(doHandleMessage);

  function parseQuery(query) {
    let Params = new Object();
    if (!query) return Params; // return empty object
    let Pairs = query.split(/[;&]/);
    for (let i = 0; i < Pairs.length; i++) {
      let KeyVal = Pairs[i].split('=');
      if (!KeyVal || KeyVal.length != 2) continue;
      let key = unescape(KeyVal[0]);
      let val = unescape(KeyVal[1]);
      val = val.replace(/\+/g, ' ');
      Params[key] = val;
    }
    return Params;
  }

  function AddIFrame(page) {
    if (document.getElementsByName('instamed').length != 0) {
      return;
    }
    let url = page + '?incontext=true';
    let iframe = document.createElement('IFRAME');
    iframe.name = 'instamed';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowtransparency', 'true');
    iframe.setAttribute('name', 'instamed');
    if (!InstaMed2.isIE7()) {
      iframe.setAttribute(
        'style',
        'z-index: 9999; display: block; background-color: transparent; border: 0px none transparent; overflow-x: hidden; overflow-y: auto; visibility: hidden; margin: 0px; padding: 0px; -webkit-tap-highlight-color: transparent; position: fixed; left: 0px; top: 0px; width: 100%; height: 100%;'
      );
    } else {
      iframe.style.setAttribute('z-index', '9999');
      iframe.style.setAttribute('display', 'block');
      iframe.style.setAttribute('background-color', 'transparent');
      iframe.style.setAttribute('border', '0px none transparent');
      iframe.style.setAttribute('overflow-x', 'hidden');
      iframe.style.setAttribute('overflow-y', 'auto');
      iframe.style.setAttribute('visibility', 'hidden');
      iframe.style.setAttribute('margin', '0px');
      iframe.style.setAttribute('padding', '0px');
      iframe.style.setAttribute('-webkit-tap-highlight-color', 'transparent');
      iframe.style.setAttribute('position', 'fixed');
      iframe.style.setAttribute('left', '0px');
      iframe.style.setAttribute('top', '0px');
      iframe.style.setAttribute('width', '100%');
      iframe.style.setAttribute('height', '100%');
    }
    iframe.setAttribute('id', 'instamed');
    iframe.setAttribute('data-incontext', 'true');
    // iframe.setAttribute("src", url);
    document.body.appendChild(iframe);

    if (InstaMed2.isIE7()) {
      window.frames['instamed'].name = 'instamed';
    }
  }

  InstaMed2.corporateID = vals['data-corporateid'];

  function addOnloadEvent(fnc) {
    if (typeof window.addEventListener != 'undefined')
      window.addEventListener('load', fnc, false);
    else if (typeof window.attachEvent != 'undefined') {
      window.attachEvent('onload', fnc);
    } else {
      if (window.onload != null) {
        let oldOnload = window.onload;
        window.onload = function (e) {
          oldOnload(e);
          window[fnc]();
        };
      } else window.onload = fnc;
    }
  }

  window.InstaMed2 = InstaMed2;

  if (typeof define === 'function') {
    define('instamed', function () {
      return InstaMed2;
    });
  }

  addOnloadEvent(InstaMed2.onReady);
})();
